module.exports = __webpack_public_path__ + "assets/img/madan.ac85dff3.jpg";